import { learningObjectivesIntro, activitiesListIntro, standardActivities, standardActivitiesClosing, closing } from './AL00000Sprint00'
import { getModuleDescriptionByClassSectionID } from '../DataAndAPIs/ClassSections'

import { CSSW3C, HTMLW3C, JavaScriptW3C, externalLink, oreillyPlaylistAF } from '../DataAndAPIs/Links'
import { reactTicTacToeLink } from '../Activities/ReactTicTacToe'
import { initialPost } from './AL00000Sprint00'

import { oreillyPlaylistSA } from '../DataAndAPIs/Links'
import { chapter03Lecture, chapter04Lecture, chapters05To12Lecture } from '../ActivityVideo/ActivityArchitecture'

export const al61200Sprint02 = (classSectionID, sprint) => {
	return ( <div>
		<h5>Sprint {sprint}: {getModuleDescriptionByClassSectionID(classSectionID, sprint-1)}</h5>

		<p>Quality of a software product goes beyond barely meeting the end user functional requirements, a good quality 
		software product must account for the needs of all stakeholders including developers, operations and maintenance 
		engineers. Although not visible to the end user, qualities such as maintainability, modifiability, availability, 
		security, interoperability, etc. are vital and the way a software product is structured highly impacts such 
		quality attributes. This sprint, you will learn about the meaning and importance of various quality attributes 
		and different ways to measure them.</p> 


		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Explain the importance of software quality attributes to non-technical audience and stakeholders</li>
			<li>Explain the meaning of key quality attributes such as maintainability, modifiability, security, 
				interoperability and others</li>
			<li>Present a convincing argument for the need to invest in non-functional quality attributes</li>
			<li>List and explain software metrics that are well-known and available in the industry</li>
			<li>Use various tools to collect quality metrics at the architectural level</li>
			<li>Read various quality measures and be able to analyze them and write reports to about a software 
				architecture quality</li>
		</ul>

		{list61200Sprint02(sprint)}
		{closing(sprint)}
	</div> )
}

export const list61200Sprint02 = (sprint) => {
		const react = () => { return externalLink('React', 'https://react.dev/')}
		const reactQuickStart = () => { return externalLink('React Quick Start', 'https://react.dev/learn')}
		const reactTicTacToe = () => { return externalLink('Intro to React - Tic-Tac-Toe', 'https://reactjs.org/tutorial/tutorial.html')}
		const reactMax = () => { return externalLink('React - The Complete Guide” ', 'https://learning.oreilly.com/videos/react-the/9781789132229/')}
		const azureStaticWebApps = () => { return externalLink('Azure Static Web Apps', 'https://aka.ms/swadocs')}
		const azureStaticReactWithPortal = () => { return externalLink('Quickstart: Azure Static site with React and using Azure portal', 'https://learn.microsoft.com/en-us/azure/static-web-apps/getting-started')}
	
	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			{standardActivities(sprint, reactTicTacToeLink())}
			<li>Within {oreillyPlaylistSA()} read “Software Architecture in Practice - Chapter 3” and watch the associated {chapter03Lecture()}</li>
			<li>Within {oreillyPlaylistAF()} scan “Learning Web Development” Preface through Chapter 4</li>
			<li>Scan {HTMLW3C()}, {CSSW3C()}, and {JavaScriptW3C()} all from W3C</li>
			<li>Review {react()} and complete {reactQuickStart()} </li>
			{initialPost(sprint)}
			<li>Within {oreillyPlaylistSA()} read “Software Architecture in Practice - Chapter 4” and watch the associated {chapter04Lecture()}</li>
			<li>Within {oreillyPlaylistSA()} read “Software Architecture in Practice - Chapters 5 to 12 Overview” and watch the associated {chapters05To12Lecture()}</li>
			<li>Within O’Reilly Books Complete {reactMax()} by Maximilian Schwarzmüller</li>
			<li>Focus on CI/CD with React by studying {azureStaticWebApps()}</li>
			<li>Complete {azureStaticReactWithPortal()} </li>
			<li>Complete {reactTicTacToe()}</li>
			{standardActivitiesClosing(sprint, reactTicTacToeLink(), '8 hours')}
		</ol>
	</div> )
}
